<template>
	<div class="list-toggle" :class="{ 'list-toggle--active': isFollowed }" @click="onFollowToggle">
		<FontAwesomeIcon :icon="faBookmark" />
		<span class="button-label">{{ isFollowed ? $t('WEBAPP_UNFOLLOW') : $t('WEBAPP_FOLLOW') }}</span>
	</div>
</template>

<script setup lang="ts">
import { useFollowList } from '@/helpers/composables/useFollowList';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

const props = defineProps<{
	isFollowed?: boolean;
	listId?: string;
	listName?: string;
}>();

const emit = defineEmits(['click']);

const { toggleFollowList } = useFollowList();

async function onFollowToggle() {
	await toggleFollowList({
		listId: props.listId ?? '',
		listName: props.listName ?? '',
		isFollowed: !!props.isFollowed,
	});
	emit('click');
}
</script>

<style lang="scss" scoped>
.list-toggle {
	cursor: pointer;
	position: relative;
	z-index: 100;
	display: flex;
	align-items: center;
	gap: 5px;

	&--active {
		color: var(--jw-yellow-500);
	}
}
</style>
